import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import css from './header.module.scss';
interface Props {
  icon: ReactElement;
  title: string;
  subtitle: string;
  chip: string;
}
export function Header(t0) {
  const $ = _c(15);
  const {
    icon,
    title,
    subtitle,
    chip
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className={css.icon}>{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <p className={css.title}>{title}</p>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subtitle) {
    t3 = <p className={css.subtitle}>{subtitle}</p>;
    $[4] = subtitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={css.text}>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== chip) {
    t5 = <span className={css.chip}>{chip}</span>;
    $[9] = chip;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t4 || $[13] !== t5) {
    t6 = <header className={css.header}>{t1}{t4}{t5}</header>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}